import { GameState } from '../../App';
import { PlayerService } from '../../services/PlayerService';
import './Player-Select.scss';

interface PlayerSelectProps {
    playerService: PlayerService;
    setGameState: (gameState: GameState) => void;
}

export const PlayerSelect: React.FC<PlayerSelectProps> = ({playerService, setGameState}) => {
    return (
        <>
            <div className={'player-select-title'}>Select your player!</div>
            <div className={'player-select-screen'}>
            {Array.from(playerService.allPlayers.entries()).map((entry) => {
                const [key, value] = entry;
                return (<PlayerButton playerService={playerService} setGameState={setGameState} name={value.name} id={key} />)
            })}
            </div>
        </>
    )
}

interface PlayerButtonProps {
    playerService: PlayerService;
    setGameState: (gameState: GameState) => void;
    name: string;
    id: number;
}

const PlayerButton: React.FC<PlayerButtonProps> = ({playerService, setGameState, name, id}) => {
    const onClickPlayer = () => {
        playerService.setCurrentPlayer(id);
        setGameState('playing');
    }
    
    return (
        <button className={'player-select-button'} onClick={onClickPlayer}>{name}</button>
    )
}